// Data Set Items

export default (data, value) => {
  Object.keys(data).forEach(key => {
    if (key === value.key) {
      data[key].items = value.items
    }
  })
  return data
}
